import React from "react";

const WithPosition = (WrappedComponent) => {

  return class HOC extends React.Component {
    componentDidMount() {
      window.scrollTo(0, 0);
    }

    render() {
      return (
        <div>
          <WrappedComponent />
        </div>
      )
    }
  }
}

export default WithPosition;